import { useForm } from "react-hook-form";
import Checkbox from "src/components/Checkbox";

const Declaration = ({ onSubmit }) => {
  // Form
  const { register, handleSubmit, formState } = useForm({
    defaultValues: { Declaration: false },
  });
  const { errors, isSubmitting } = formState;

  return (
    <>
      <h2>Declaration</h2>

      <div className="form-terms">
        <p>
          I wish to apply for admission to the Institute and will abide by
          institute regulations. I undertake that, if admitted, I will make
          every effort to complete the course. The information I have supplied
          is correct and true. I realise that if I have supplied false
          information or neglected to provide additional information that could
          prove important, any offer of a place may be withdrawn. If any of this
          information changes I will inform the Institute. If I am currently in
          receipt of qualifying benefit I agree to inform the Institute
          immediately if my benefit status changes. I understand that I may be
          asked to provide evidence of continued eligibility to fee remission.
        </p>
        <p>
          Should your personal data change (e.g. Address), please notify us as
          soon as possible.
        </p>
        <p>
          The Institute collects information about staff and students for
          various administrative, academic, and health & safety reasons. The
          Data Protection Act 1998 requires your consent before we can obtain
          this information. Should you require further information regarding
          this please contact Admissions Information & Enquiries.
        </p>
        <ul>
          <li>
            I agree to South Central Institute of Technology obtaining,
            processing and storing personal information obtained from this
            electronic form, or any other information obtained from me, or other
            people, whilst I am a student. I agree that the information obtained
            can be used for purposes connected with my studies and health &
            safety whilst on the premises or for any other legitimate reason.
          </li>
          <li>
            I agree information may be shared with other organisations for
            education, training, employment and well-being related purposes,
            including research. You may be contacted after you have completed
            your programme of learning to establish whether you have entered
            employment or gone onto further training.
          </li>
          <li>
            I agree to the institute publishing data on my achievement as a
            student. I also confirm that any photographs or video footage taken
            of me with my permission may be used for marketing purposes.
          </li>
          <li>
            I give permission for the South Central Institute of Technology to
            contact me with communications other than those essential to the
            process, with news, event invitations and useful information that
            may be of interest.
          </li>
        </ul>

        <p>
          By providing your mobile telephone number and email address you are
          agreeing that the institute can contact you by text and email as well
          as by telephone and post. If you have any concerns about this please
          contact the institute to discuss.
        </p>
      </div>

      <form onSubmit={handleSubmit(onSubmit)}>
        <Checkbox
          label="By ticking this box, I confirm that I have read the declaration above and agree to the statements within it. Ticking this box replaces my signature on this electronic form"
          name="Declaration"
          register={register}
          validation={{
            required:
              "Please tick this box after reading the above declaration",
          }}
          error={errors.Declaration}
        />

        <button type="submit" className="form-submit" disabled={isSubmitting}>
          {isSubmitting ? "Saving" : "Submit"}
        </button>
      </form>
    </>
  );
};

export default Declaration;
